import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Components
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';

//Helpers
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

//Api
import relatorio_api from '../../../api/relatorio_api';
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import RelatorioDestinos from './RelatorioDestinos';

// import { Container } from './styles';
function initialStateFiltros() {
  return {
    status: "Todos",
    modalidadeId: 0,
    modalidadeId_selected: { value: null, label: "Todos" },
    nomeRelatorio: "Relatórios - Destinos"
  }
}

function DestinosRelatorio() {
  //Estado que valida os possiveis erros nos campos de filtros
  const [errors, setErrors] = useState({});

  //Guarda os filtros obrigatorios
  const campos = [
    objCampo({ name: "status", required: true }),
    objCampo({ name: "modalidadeId_selected", required: true })
  ];

  //Estado de controle do loading na tela
  const [loading, setLoading] = useState();

  //Estado que guarda os valores dos filtros
  const [filtros, setFiltros] = useState(initialStateFiltros());

  //Opções de modalidades de coleta
  const [optionsModalidades, setOptionsModalidades] = useState([]);

  //Estado que guarda os dados do relatorio
  const [dadosRelatorio, setDadosRelatorio] = useState(null);

  //Opções do select de status
  const optionsStatus = [
    { value: "Todos", text: "Todos" },
    { value: "Ativo", text: "Ativo" },
    { value: "Inativo", text: "Inativo" },
  ]

  //Change para os campos modalidade e transportadores
  const onChangeSelected = (e, select) => {
    const { name } = select;
    setFiltros({
      ...filtros,
      [name]: e,
      [name.split("_")[0]]: e ? e.value : 0
    });
  }

  //Change para os campos data inicial, data final e status
  const onChangeFiltros = (e) => {
    const { name, value } = e.target;
    setFiltros({
      ...filtros,
      [name]: value
    })
  }

  //Variavel de navegação na tela
  const navigate = useNavigate();

  const loadModalidades = () => {
    setLoading(true);
    modalidadeColeta_api.GetList().then(response => {
      response.data = response.data.map(value => {
        return { value: value.id, label: value.descricao };
      });
      setOptionsModalidades([{ value: null, label: "Todos" }, ...response.data]);
    }).catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  //Função que puxa os dados do relatorio
  const carregarRelatorio = () => {
    const _errors = validarCampos(filtros, campos);
    if (_errors[1].length > 0) {
      setErrors(_errors[0]);
      return;
    }

    setLoading(true);
    relatorio_api.RelatorioDestinos(filtros)
      .then(response => {
        response.data = response.data.map(value => {
          value.fone = !!value.fone ? mascaras.telefoneMask(value.fone) : "";
          return value;
        })
        setDadosRelatorio(response.data);
      })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  const handleVolta = () => {
    setDadosRelatorio(null);
    setFiltros(initialStateFiltros());
  }

  useEffect(() => {
    loadModalidades();
  }, []);

  if (dadosRelatorio) {
    return <RelatorioDestinos
      btnVoltar={handleVolta}
      filtros={filtros}
      dadosRelatorio={dadosRelatorio}
    />
  }

  return (
    <MainCard btnVoltarInTop={() => navigate(-1)}>
      {loading && <Loading />}
      <h4>Relatório dos Destinos</h4>
      <Row sm="12" md="6" lg="4">
        <Col sm="12" md="6" lg="4">
          <TextField
            placeholder='Selecione'
            name="modalidadeId_selected"
            label={"* Modalidade"}
            type={"select"}
            searchable
            value={filtros?.modalidadeId_selected}
            invalid={!!errors.modalidadeId_selected}
            onChange={onChangeSelected}
            options={optionsModalidades}
          />
        </Col>
        <Col sm="12" md="6" lg="4">
          <TextField
            name="status"
            label={"* Status"}
            type={"select"}
            onChange={onChangeFiltros}
            options={optionsStatus}
            value={filtros.status}
            invalid={!!errors.status}
          />
        </Col>
        <Col sm="12" md="6" lg="3" style={{ marginTop: "1.875rem" }}>
          <Button
            className='w-100 fw-bold'
            color='info text-light'
            onClick={carregarRelatorio}>Gerar Relatório</Button>
        </Col>
      </Row>
    </MainCard>
  );
}

export default DestinosRelatorio;